var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerSimpleLow = function SvgIconSpeakerSimpleLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 3a1 1 0 0 0-1.614-.79l-6.48 5.04H3A1.75 1.75 0 0 0 1.25 9v6A1.75 1.75 0 0 0 3 16.75h4.157l6.48 5.04A1 1 0 0 0 15.25 21zM8.114 9.04l5.136-3.995v13.91l-5.136-3.994a1 1 0 0 0-.614-.211H3.25v-5.5H7.5a1 1 0 0 0 .614-.21M19 9.75a1 1 0 1 0-2 0v4.5a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerSimpleLow;